export const V2_URL = 'https://portal.goconfigur.com/';
